import { render, staticRenderFns } from "./v_StandAlone.vue?vue&type=template&id=ff4d8d3e&scoped=true&"
import script from "./v_StandAlone.vue?vue&type=script&lang=js&"
export * from "./v_StandAlone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4d8d3e",
  null
  
)

export default component.exports